const BASE = '/v1/Analytics';

export default (instance) => ({
  getSummary: (params = {}) => instance.get(`${BASE}/summary`, { params }),
  getThroughput: (params = {}) => instance.get(`${BASE}/throughput`, { params }),
  getDefectReasonBreakdown: (params = {}) => instance.get(`${BASE}/defect-reasons`, { params }),
  getStationUtilization: (params = {}) => instance.get(`${BASE}/station-utilization`, { params }),
  getCycleTimeByStep: (params = {}) => instance.get(`${BASE}/cycle-time`, { params })
});
